import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store';
import auth from './routes/auth';
import volunteer from './routes/volunteer';
import patient from './routes/patient';
import presumptive from './routes/presumptive';
import activity from './routes/activity';
import dots from './routes/dots';
import report from './routes/report';

Vue.use(VueRouter);


const routes = [
  ...auth,
  ...volunteer,
  ...patient,
  ...presumptive,
  ...activity,
  ...dots,
  ...report,
  {
    path: "/export/presumptive",
    name: "presumptiveExport",
    component: () => import("@/views/export/Export.vue"),
    meta: { forAuth: true },
},
{
  path: "/export/patient-enroll",
  name: "patientEnrollExport",
  component: () => import("@/views/export/PatientEnrollExport.vue"),
  meta: { forAuth: true },
},
 {
    path: "/export/outcome-export",
    name: "outcomeExport",
    component: () => import("@/views/export/OutcomeExport.vue"),
    meta: { forAuth: true },
},
{
  path: "/export/dots-patient-export",
  name: "patientEnrollExport",
  component: () => import("@/views/export/DotPatientExport.vue"),
  meta: { forAuth: true },
},
{
  path: "/export/complementary-export",
  name: "complementaryPatientExport",
  component: () => import("@/views/export/ComplementaryPatientExport.vue"),
  meta: { forAuth: true },
},

{
  path: "/export/ci",
  name: "ciExport",
  component: () => import("@/views/export/CiExport.vue"),
  meta: { forAuth: true },
},
{
  path: "/export/familymember-export",
  name: "familymemberExport",
  component: () => import("@/views/export/FamilymemberExport.vue"),
  meta: { forAuth: true },
},

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(toRoute => toRoute.meta.forAuth)) {
    if (store.state.Admin.isLoggedIn)
      next();
    else
      next('/login')
  }
  //isLoggedIn state true but want to access the login page it will redirect to home page
  else if (store.state.Admin.isLoggedIn && to.name == 'Login') next('/')

  next()

});

export default router;
